module.exports = __webpack_public_path__ + "img/7.099c07f3.png";